import { supabase, isSupabaseConfigured } from "../lib/supabaseClient";

const PROFILE_TABLE = "client_profiles";

const mapProfileRecord = (record) => ({
    id: record.id,
    fullName: record.full_name ?? null,
    company: record.company ?? null,
    phone: record.phone ?? null,
    createdAt: record.created_at ?? null,
});

const ensureSupabase = () => {
    if (!isSupabaseConfigured || !supabase) {
        throw new Error(
            "Supabase yapılandırılmadan müşteri profili güncellenemez. Lütfen ortam değişkenlerini tanımlayın."
        );
    }
};

export const upsertClientProfile = async ({ id, fullName, company, phone }) => {
    ensureSupabase();
    const payload = {
        id,
        full_name: fullName ?? null,
        company: company ?? null,
        phone: phone ?? null,
    };

    const { data, error } = await supabase.from(PROFILE_TABLE).upsert(payload, { onConflict: "id" }).select().maybeSingle();

    if (error) {
        console.error("Supabase upsertClientProfile error", error);
        throw error;
    }

    return data ? mapProfileRecord(data) : payload;
};

export const fetchClientProfile = async () => {
    ensureSupabase();
    const { data, error } = await supabase.from(PROFILE_TABLE).select("id, full_name, company, phone, created_at").maybeSingle();

    if (error) {
        console.error("Supabase fetchClientProfile error", error);
        throw error;
    }

    return data ? mapProfileRecord(data) : null;
};
